module.exports = __webpack_public_path__ + "static/img/about-image2.9493c97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-image2.jpg
// module id = 35
// module chunks = 20